<template>
  <div v-if="live">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">
            پخش
            {{ live.id }}
          </h3>
        </div>
        <div class="card-toolbar">
          <div v-show="!liveLoaded" class="spinner mr-3"></div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div
            :class="[
              liveEvent.created_at !== undefined ? 'col-md-12' : 'col-md-6'
            ]"
          >
            <div class="d-flex justify-content-between pt-4">
              <div class="d-flex flex-column flex-root">
                <span class="font-weight-bolder mb-2">شروع</span>
                <span class="opacity-70 text-nowrap font-family-base" dir="ltr">
                  {{ formatDate(live.created_at) }}
                </span>
              </div>
              <div
                v-if="liveEvent.created_at !== undefined"
                class="d-flex flex-column flex-root"
              >
                <span class="font-weight-bolder mb-2">پایان</span>
                <span class="opacity-70 text-nowrap font-family-base" dir="ltr">
                  {{ formatDate(liveEvent.created_at) }}
                </span>
              </div>
              <div
                v-if="liveEvent.details && liveEvent.details.length"
                class="d-flex flex-column flex-root mb-5"
              >
                <span class="font-weight-bolder mb-2">مدت</span>
                <span class="opacity-70">
                  {{ prettyTime(liveEvent.details.length) }}</span
                >
              </div>
              <div v-else class="d-flex flex-column flex-root mb-5">
                <span class="font-weight-bolder mb-2">مدت</span>
                <span class="opacity-70"> {{ prettyTime(liveDuration) }}</span>
              </div>
              <div
                v-if="liveEvent.details && liveEvent.details.error"
                class="d-flex flex-column flex-root"
              >
                <span class="font-weight-bolder mb-2">توضیحات</span>
                <span class="opacity-70"> {{ liveEvent.details.error }}</span>
              </div>
              <div v-if="isAdmin" class="d-flex flex-column flex-root">
                <span class="font-weight-bolder mb-2">سرور</span>
                <span class="opacity-70 text-nowrap font-family-base" dir="ltr">
                  {{ live.server }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6" v-if="liveEvent.created_at === undefined">
            <PlayerComp
              :live="program"
              v-if="programLoaded && program.public_hls"
            ></PlayerComp>
          </div>
        </div>

        <div v-if="liveDestinations.length > 0" class="mt-10">
          <div class="font-size-h6-lg mb-4">مقصد‌ها</div>
          <TableComp :liveDestinations="fLiveDestinations"></TableComp>
        </div>
        <div v-if="liveDestinations.length === 0">
          <div class="alert alert-primary mt-5" role="alert">
            مقصدی یافت نشد.
          </div>
        </div>

        <div v-if="live.archives[0]">
          <div class="font-weight-bolder mt-10 mb-5">فایل ها</div>
          <div class="row">
            <div class="col-sm-3">
              <div class="card gutter-b card-stretch">
                <div class="card-body">
                  <div
                    class="d-flex flex-column align-items-center cursor-pointer"
                    @click="downloadArchive(live.archives[0])"
                  >
                    <img
                      alt=""
                      class="max-h-65px"
                      src="/media/svg/files/mp4.svg"
                    />
                    <span
                      class="text-dark-75 font-weight-bold mt-15 font-size-sm"
                    >
                      {{ live.id }}.mp4
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  SET_ACTIONS,
  ADD_ACTIONS,
  REMOVE_BUTTON_ACTIONS
} from "@/core/services/store/actions.module";
import {
  FETCH_LIVE,
  FETCH_LIVE_DESTINATIONS,
  SET_LIVE,
  STOP_LIVE
} from "@/core/services/store/lives.module";
import {
  FETCH_PROGRAM,
  START_PROGRAM,
  GET_PROGRAM_FILE_URL
} from "@/core/services/store/programs.module";
import PlayerComp from "@/view/pages/programs/comp/PlayerComp.vue";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import TableComp from "@/view/content/TableComp.vue";

export default {
  name: "programs-show",
  data() {
    return {
      liveLoaded: false,
      programLoaded: false,
      liveInterval: null,
      liveDuration: 0,
      timer: null,
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin")
    };
  },
  components: {
    PlayerComp,
    TableComp
  },
  mounted() {
    let liveId = this.$route.params.live;
    let programId = this.$route.params.program;
    this.getProgram(programId);

    this.$store.commit(SET_LIVE, {});
    this.$store.dispatch(SET_ACTIONS, {});

    this.update(programId, liveId);
    this.liveInterval = setInterval(() => {
      this.update(programId, liveId);
    }, 8000);
  },
  beforeDestroy: function() {
    clearInterval(this.liveInterval);
    this.liveInterval = null;
  },
  methods: {
    setBreadcrumbs() {
      let programsRouteName = "programs-index";
      let programRouteName = "programs-show";

      let items = [];
      if (this.isCompany) {
        programsRouteName = "company-programs-index";
        programRouteName = "company-programs-show";
        items.push({
          title: this.currentUserProperty.title ?? "شرکت",
          route: { name: "company-dashboard" }
        });
      }
      if (this.isAdmin) {
        programsRouteName = "admin-programs-index";
        programRouteName = "admin-programs-show";
        items.push({
          title: "مدیریت",
          route: { name: "admin-dashboard" }
        });
      }
      items.push({ title: "برنامه‌‌ها", route: { name: programsRouteName } });
      items.push({
        title: this.live.program_id,
        route: { name: programRouteName, params: { id: this.live.program_id } }
      });
      items.push({ title: "پخش " + this.live.id });
      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      let links = [
        {
          name: "بازگشت",
          to: {
            name: "programs-show",
            params: { id: this.program.id }
          }
        }
      ];

      if (this.isAdmin) {
        links = [
          {
            name: ' <i class=" flaticon-user ml-2  font-size-h5 "></i>',
            to: {
              name: "admin-users-show",
              params: { id: this.program.user_id }
            },
            class: "btn-primary"
          }
        ];
      } else if (this.isCompany) {
        links = [
          {
            name: ' <i class=" flaticon-user ml-2  font-size-h5 "></i>',
            to: {
              name: "company-users-show",
              params: { id: this.program.user_id }
            },
            class: "btn-primary"
          }
        ];
      }

      this.$store.dispatch(ADD_ACTIONS, {
        links: links
      });
    },
    setButtons() {
      let startBtn = {
        name: '<i class="flaticon2-arrow"></i>شروع',
        event: "start-program-event",
        class: "btn-success",
        id: "start-program-btn"
      };
      let stopBtn = {
        name: '<i class="fas fa-stop"></i>توقف',
        event: "stop-program-event",
        class: "btn-danger",
        id: "stop-program-btn"
      };

      let buttons = [];
      if (this.program.type !== 1 && this.live.id === undefined) {
        buttons.push(startBtn);
      } else {
        this.$store.commit(REMOVE_BUTTON_ACTIONS, startBtn);
      }
      if (
        this.live.id &&
        !this.isStopped &&
        !this.isFailed &&
        !this.live?.events.length
      ) {
        buttons.push(stopBtn);
      } else {
        this.$store.commit(REMOVE_BUTTON_ACTIONS, stopBtn);
      }

      this.$store.dispatch(ADD_ACTIONS, {
        buttons: buttons
      });

      this.eventHub.$on("start-program-event", this.start);
      this.eventHub.$on("stop-program-event", this.stop);
    },
    start() {
      Swal.fire({
        title: "",
        text: "آیا برنامه شروع شود؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          let startBtn = document.getElementById("start-program-btn");
          this.disableBtn(startBtn);

          this.$store
            .dispatch(START_PROGRAM, this.program.id)
            .then(() => {
              this.getLives();
              this.checkButtons = true;
              this.enableBtn(startBtn);
            })
            .catch(() => {
              this.enableBtn(startBtn);
            });
        }
      });
    },
    stop() {
      Swal.fire({
        title: "",
        text: "آیا از توقف برنامه‌ اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          let stopBtn = document.getElementById("stop-program-btn");
          this.disableBtn(stopBtn);

          this.$store
            .dispatch(STOP_LIVE, this.live.id)
            .then(() => {
              this.getLives();
              this.checkButtons = true;
              this.enableBtn(stopBtn);
            })
            .catch(() => {
              this.enableBtn(stopBtn);
            });
        }
      });
    },
    liveDestinationIsStopped(liveDestination) {
      return [3, 4].includes(liveDestination.last_event);
    },
    liveDestinationIsFailed(liveDestination) {
      return liveDestination.last_event === 2;
    },
    startTimer() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          this.liveDuration++;
        }, 1000);
      }
    },
    getProgram(programId) {
      this.$store.dispatch(FETCH_PROGRAM, programId).then(() => {
        this.programLoaded = true;
        this.setActions();
      });
    },
    update(programId, liveId) {
      if (this.isFailed || this.isStopped) {
        return;
      }

      this.liveLoaded = false;

      this.$store
        .dispatch(FETCH_LIVE, liveId)
        .then(() => {
          this.liveLoaded = true;
          this.liveDuration = this.getDuration(this.live.created_at);
          this.startTimer();

          this.setBreadcrumbs();
          if (this.programLoaded) {
            this.setButtons();
          }

          if (this.isStopped || this.isFailed) {
            clearInterval(this.liveInterval);
            this.liveInterval = null;
          }
        })
        .catch(() => {
          this.liveLoaded = true;
        });
      this.$store.dispatch(FETCH_LIVE_DESTINATIONS, liveId);
    },
    downloadArchive(path) {
      this.$store
        .dispatch(GET_PROGRAM_FILE_URL, {
          program: this.program.id,
          path: path
        })
        .then(url => {
          Swal.fire({
            html: `<a class="btn btn-primary btn-lg" href="${url}" target="_blank" download>دانلود</a>`,
            showCloseButton: false,
            showCancelButton: false,
            showConfirmButton: false
          });
        });
    }
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "program",
      "destinationTypes",
      "live",
      "liveDestinations"
    ]),
    liveEvent() {
      return this.live.events !== undefined && this.live.events[0] !== undefined
        ? this.live.events[0]
        : {};
    },
    isStopped() {
      return [3, 4].includes(this.live.last_event);
    },
    isFailed() {
      return this.live.last_event === 2;
    },
    fLiveDestinations() {
      let data = [];
      let badges = {
        0: "badge-danger",
        1: "badge-warning",
        2: "badge-danger",
        3: "badge-primary",
        4: "badge-warning"
      };

      this.liveDestinations.forEach(liveDestination => {
        if (liveDestination.destination) {
          let name = liveDestination.destination.name ?? "";
          let image = `/media/destinations/${
            this.destinationTypes[liveDestination.destination.type]
          }.png`;

          let start = liveDestination.created_at,
            end = undefined,
            length = this.prettyTime(
              this.getDuration(liveDestination.created_at)
            ),
            visitors = "",
            error = "",
            badge = "badge-success";
          if (
            liveDestination.events !== undefined &&
            liveDestination.events[0] !== undefined
          ) {
            end = liveDestination.events[0].created_at;
            length = liveDestination.events[0].details.length
              ? this.prettyTime(liveDestination.events[0].details.length)
              : "-";
            visitors = liveDestination.events[0].details.visitors_count
              ? liveDestination.events[0].details.visitors_count
              : "";
            error = liveDestination.events[0].details.error ?? "";
            badge = badges[liveDestination.events[0].type]
              ? badges[liveDestination.events[0].type]
              : "";
          }

          data.push({
            id: liveDestination.id,
            type: liveDestination.destination.type,
            last_event: liveDestination.last_event,
            name: name,
            image: image,
            badge: badge,
            start: this.formatDate(start),
            end: this.formatDate(end),
            length: length,
            visitors: visitors,
            error: error
          });
        }
      });
      this.sortArray(data);
      return data;
    }
  }
};
</script>
